import { ConjuctionType } from './custom-types.model';
import { TranslationsTypes } from './translation.model';

export type PolicyID = string;
export type PolicyConfiguration = string;
export type RuleIDType = string;

export interface IPolicyAuthState {
    policiesAuth: [];
    count: number;
    policiesAuthLoading: boolean;
    mainRule: IRule;
}

export interface IPolicyOldAuthState {
    policiesAuth: [];
    count: number;
    policiesAuthLoading: boolean;
    rules: IRule[];
}

export interface IPolicyAuth {
    '@odata.type': string;
    Id: string;
    Created: Date;
    CreatedBy: string;
    LastModified: Date;
    LastModifiedBy: string;
    Configuration: PolicyConfiguration;
    TenantId: string;
    DisplayName: string;
    IsDefault: boolean;
    Elements: IPolicyAuthElement[];
    'Elements@odata.context': string;
}

export interface IPolicyAuthElement {
    PolicyId: string;
    Enabled: boolean;
    Type: string;
    Configuration: string;
}

export interface ICreateCondition {
    label: TranslationsTypes;
    value: ConditionTypes;
    icon: JSX.Element;
    properties: ICriteria[];
}

export interface ICreateAction {
    label: string;
    value: ActionTypes;
    icon: JSX.Element;
}

export interface ICriteria {
    value: CriteriaTypes;
    label: TranslationsTypes;
    filter?: boolean;
    filters?: any;
    attribute?: boolean;
    list?: boolean;
    ip?: boolean;
    chip?: string;
    chipName?: string;
    time?: boolean;
}

export interface IStringFilter {
    value: StringFilterTypes;
    label: string;
    requiresValue: boolean;
}

export interface IRule {
    operator: ConjuctionType;
    conditions: ICondition[];
    actions: IAction[];
    elseRules: IAdditionalRule[];
    elseActions: IAction[];
    id?: RuleIDType;
}

export interface IAdditionalRule {
    operator: ConjuctionType;
    conditions: ICondition[];
    actions: IAction[];
    elseActions?: IAction[];
    id?: RuleIDType;
}

export interface ICondition {
    object: IConditionData | null;
    id: string;
}

export interface IAction {
    object: IActionData | null;
    id: string;
}

export interface IElseAction {
    object: IElseActionData | null;
    id: string;
}

export interface IConditionData {
    type: ConditionTypes;
    property: CriteriaTypes;
    filter: any;
}

export interface IActionData {
    Type: ActionTypes;
    Configuration: any;
}

export interface IElseActionData {
    Type: ActionTypes;
    Configuration: any;
}

export interface IPolicyDefaults {
    ComponentName: string;
    SupportedMethods: string[];
    FirstFactorMethods: string[];
    SecondFactorMethods: string[];
    Session: IPolicyDefaultsSession;
}

export interface IPolicyDefaultsSession {
    SignOutOnClose: boolean;
    AccessTokenLifetime: string;
    RefreshTokenEnabled: boolean;
    RefreshTokenLifetime: string;
}

export interface IAddPolicy {
    '@odata.type': string;
    DisplayName: string;
    IsDefault: boolean;
    Configuration: string;
}

export interface IAdditionalRuleConfiguration {
    operator: ConjuctionType;
    conditions: IConditionData[];
    actions: IActionData[];
    elseActions?: IElseActionData[];
}

export interface IRuleConfiguration {
    operator: ConjuctionType;
    conditions: IConditionData[];
    actions: IActionData[];
    elseRules: IAdditionalRuleConfiguration[];
    elseActions: IElseActionData[];
}

export enum RuleElements {
    condition = 'condition',
    action = 'action',
    elseAction = 'elseAction'
}

export enum ActionTypes {
    allowedMethods = 'AllowedMethods',
    requiredMethods = 'RequiredMethods',
    sessionLifetime = 'SessionLifetime',
    trustedDevice = 'TrustedDevice',
    denyAccess = 'DenyAccess'
}

export enum ConditionTypes {
    user = 'User',
    currentTime = 'CurrentTime',
    location = 'Location',
    ip = 'IP',
    forwardIP = 'ForwardIP',
    trustedDevice = 'TrustedDevice',
    ipConf = 'ip'
}

export enum CriteriaTypes {
    signin = 'signin',
    group = 'group',
    notingroup = 'notingroup',
    role = 'role',
    attribute = 'attribute',
    before = 'before',
    after = 'after',
    country = 'country',
    state = 'state',
    city = 'city',
    postalcode = 'postalcode',
    inrange = 'inrange',
    notinrange = 'notinrange',
    forwardinrange = 'forwardinrange',
    forwardnotinrange = 'forwardnotinrange',
    trusted = 'trusted',
    untrusted = 'untrusted'
}

export enum StringFilterTypes {
    is = 'is',
    isnot = 'isnot',
    startswith = 'startswith',
    endswith = 'endswith',
    contains = 'contains',
    notcontains = 'notcontains',
    isempty = 'isempty',
    notempty = 'notempty'
}

export enum TenantTypes {
    mme = 'MME',
    msp = 'MSP'
}